import { Stack, styled, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PropertyMulti } from "src/context/Property/Builder/PropertyBuilder";
import { PropertyHeader, ValueSwitch } from "./ValueSwitch";
import { Fragment } from "react/jsx-runtime";

type MultiPropertyProps = {
    startProperty: PropertyMulti;
    endProperty: PropertyMulti;
};
export const MultiProperty = (props: MultiPropertyProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { startProperty, endProperty } = props;

    const startTitle = t("actionPlan.value_in_year", { year: startProperty.campaign?.label });
    const targetTitle = `${t("Goal")} ${endProperty.campaign?.label}`;

    const allChildren = endProperty.property.children;
    const maxIterations = endProperty.content.length;

    const childrenWhitelist = endProperty.property.actionChildrenIds ?? [];
    const isWhitelistActivated = childrenWhitelist.length > 0;
    return (
        <Stack padding={theme.spacing(3)}>
            <Stack
                gap={theme.spacing(3)}
                padding={theme.spacing(3, 0, 3, 0)}
                border={`1px solid ${theme.custom.grey[500]}`}
                borderRadius={theme.spacing(1.5)}
            >
                {endProperty.content.map((propertyGroup, rowIndex) => {
                    // This dimension mean that I am in a GROUP of Property;

                    const propertyGroupsOfStart = startProperty.content[rowIndex] ?? [];
                    const borderStyle = rowIndex + 1 === maxIterations ? "none" : `1px solid ${theme.custom.grey[500]}`;
                    // I want to use the `rowIndex` to find the `startingProperty` that matches.
                    // Tomorrow, I would want to have both `Groups of Properties` completely independant.
                    // Because I can't guarantee the orders of the Multivalued group.
                    return (
                        <Stack
                            key={`${rowIndex}-multivalue`}
                            borderBottom={borderStyle}
                            gap={theme.spacing(2)}
                            paddingBottom={theme.spacing(2)}
                        >
                            <PropertyHeader startTitle={startTitle} targetTitle={targetTitle} />
                            {allChildren?.flatMap((subproperty) => {
                                const shouldShow =
                                    isWhitelistActivated === false ? true : childrenWhitelist.includes(subproperty.id);

                                if (shouldShow === false) {
                                    return [];
                                }
                                // The subproperty in SSQ Children defines the order in the skeleton of Multi;
                                // Now, with `rowIndex` + `subpropertyId` we can find the right element;

                                const foundStarting = propertyGroupsOfStart.find(
                                    (item) => item.property.id === subproperty.id,
                                );
                                const foundTarget = propertyGroup.find((item) => item.property.id === subproperty.id);
                                return [
                                    <Stack key={`${rowIndex}-${subproperty.id}-inner`} flexDirection={"row"}>
                                        <CenteredStack
                                            borderRight={`1px solid ${theme.custom.grey[1400]}`}
                                            gap={theme.spacing(0.5)}
                                        >
                                            <Fragment>
                                                <ValueSwitch
                                                    property={foundStarting}
                                                    title={foundStarting?.property.title}
                                                    variant="readonly"
                                                />
                                            </Fragment>
                                        </CenteredStack>
                                        <CenteredStack>
                                            <ValueSwitch property={foundTarget} title={foundTarget?.property.title} />
                                        </CenteredStack>
                                    </Stack>,
                                ];
                            })}
                        </Stack>
                    );
                })}
            </Stack>
        </Stack>
    );
};

const CenteredStack = styled(Stack)(({ theme }) => ({
    width: "50%",
    justifyContent: "center",
    alignItems: "start",
    paddingLeft: theme.spacing(2),
}));
